/** @module Apparel/MassCopyStyles */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/locale",
	"csi/types",
	"csi/widget/MessageDialog"
], function(declare,lang,Controller,locale,types,MessageDialog) {

	/**
	* Get the displayed value of the field
	* @param {field} field - the field control
	* @param {string} value - the value of the field
	* @return {string} - the displayed value of the field
	*/
	function _getDisplayedValue(field, value){
		var store = field.m_control.get("store");
		return store.get(value)[store.labelProperty];
	};

	return declare(Controller, {
		postProcessSuccess: function(){
			var fd = this.getFormData();
			var fromSeasonName = _getDisplayedValue(fd.getField("FromSeason"), fd.getFieldValue("FromSeason"));
			var toSeasonName = _getDisplayedValue(fd.getField("ToSeason"), fd.getFieldValue("ToSeason"));
			var exeDate = types.formatTime(fd.getFieldValue("ExecutionSchedule"), types.FORMAT_DATETIME);
			var msg = this.getString("_Result", [fromSeasonName, toSeasonName, exeDate]);
			this.confirmAction({
				buttons: [MessageDialog.BUTTON_OK],
				message: msg,
				materialIcon: MessageDialog.ICON_INFO,
				onResponse: function() {}
			});
		}
	});
});